import ColCompoundHome from './home';
import Test from './test';
export default {
    ColCompoundHome,
    Test,
}
